import {useQuery, type UseQueryResult} from '@tanstack/react-query'

import {UrlBypassData} from 'interfaces'
import {PoliciesService} from 'services/api'

export const GET_URL_BYPASS_RESOURCE_QUERY_KEY = 'getUrlBypassResourceData'

export const getUrlBypassResourceQueryKey = (
  policyName: string,
): readonly [typeof GET_URL_BYPASS_RESOURCE_QUERY_KEY, string] => [
  GET_URL_BYPASS_RESOURCE_QUERY_KEY,
  policyName,
]

interface GetUrlBypassResourceQueryProps {
  policyName: string
  enabled?: boolean
}

export const useGetUrlBypassResource = ({
  policyName,
  enabled = true,
}: GetUrlBypassResourceQueryProps): UseQueryResult<UrlBypassData> =>
  useQuery({
    queryKey: getUrlBypassResourceQueryKey(policyName),
    queryFn: () => PoliciesService.getUrlBypass(policyName),
    select: ({data}): UrlBypassData => data,
    enabled,
    refetchOnWindowFocus: false,
  })
